// Mock data for Checkout Coffee website

export const branches = [
  {
    id: 1,
    name: "City Center Mall",
    address: "City Center Doha, Doha, Qatar",
    status: "open",
    mapUrl: "https://maps.google.com/?q=City+Center+Doha+Qatar",
    hours: "7:00 AM - 12:00 AM"
  },
  {
    id: 2,
    name: "Villaggio Mall",
    address: "Villaggio Mall, Al Waab, Doha, Qatar",
    status: "open",
    mapUrl: "https://maps.google.com/?q=Villaggio+Mall+Doha+Qatar",
    hours: "7:00 AM - 12:00 AM"
  },
  {
    id: 3,
    name: "Lagoona Mall",
    address: "Lagoona Mall, West Bay, Doha, Qatar",
    status: "open",
    mapUrl: "https://maps.google.com/?q=Lagoona+Mall+Doha+Qatar",
    hours: "7:00 AM - 12:00 AM"
  },
  {
    id: 4,
    name: "Landmark Mall",
    address: "Landmark Mall, Doha, Qatar",
    status: "open",
    mapUrl: "https://maps.google.com/?q=Landmark+Mall+Doha+Qatar",
    hours: "7:00 AM - 12:00 AM"
  },
  {
    id: 5,
    name: "Dar Al Salam Mall",
    address: "Dar Al Salam Mall, Doha, Qatar",
    status: "open",
    mapUrl: "https://maps.google.com/?q=Dar+Al+Salam+Mall+Doha+Qatar",
    hours: "7:00 AM - 12:00 AM"
  }
];

export const socialMedia = {
  instagram: "https://www.instagram.com/thatcheckoutcoffee/",
  facebook: "https://www.facebook.com/CheckoutCoffee"
};

export const contactInfo = {
  email: "info@checkoutcoffee.com",
  hours: "Monday - Sunday: 7:00 AM - 12:00 AM"
};

export const aboutContent = {
  heading: "Premium Coffee, Expertly Crafted",
  description: "Checkout Coffee is more than just a coffee shop—it's an experience. Located in Doha's premier malls, we serve expertly crafted beverages using the finest beans, prepared by trained baristas who are passionate about every cup. From rich Espresso to smooth Flat White, traditional Kadak Tea to specialty drinks, we deliver consistency, flavor, and excellence in every sip.",
  features: [
    {
      title: "Premium Quality",
      description: "High-quality beans sourced and roasted to perfection"
    },
    {
      title: "Expert Baristas",
      description: "Trained professionals dedicated to crafting your perfect cup"
    },
    {
      title: "Fast & Convenient",
      description: "Located in major malls for easy access and quick service"
    },
    {
      title: "Consistent Excellence",
      description: "Every cup meets our high standards of quality and taste"
    }
  ]
};
